import React from "react";
import { Helmet } from "react-helmet";

/**
 * IndexableHead head that allows a URL to be indexable.
 * (basically this is the equivalent of not having a robots tag, but we need one as we attach a noindex tag to the HOC)
 * Keep in mind that this does not force the url to be indexed like a <meta name="robots" content="index"> would.
 */
export const IndexableHead = () => {
  return (
    <Helmet>
      <meta name="robots" content="all" />
    </Helmet>
  );
};
